import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const IMAGES = {
  heroPortrait: "https://images.unsplash.com/photo-1775855732829-5935734a08ff?auto=format&fit=crop&w=1400&q=80",
  group: "https://images.unsplash.com/photo-1633329712165-4e578376eb87?auto=format&fit=crop&w=1400&q=80",
  about: "https://images.unsplash.com/photo-1758613171146-8d15cfacc14e?auto=format&fit=crop&w=1400&q=80",
  founder: "https://images.unsplash.com/photo-1760551937980-74ed4e89c8b0?auto=format&fit=crop&w=1200&q=80",
  salon: "https://images.pexels.com/photos/853427/pexels-photo-853427.jpeg?auto=compress&cs=tinysrgb&w=1400",
  portraitDark: "https://images.unsplash.com/photo-1593351799227-75df2026356b?auto=format&fit=crop&w=1200&q=80",
  portraitFace: "https://images.unsplash.com/photo-1521146764736-56c929d59c83?auto=format&fit=crop&w=1200&q=80",
  colorWork: "https://images.unsplash.com/photo-1605980766335-d3a41c7332a1?auto=format&fit=crop&w=1200&q=80",
  colorHands: "https://images.unsplash.com/photo-1617391654484-2894196c2cc9?auto=format&fit=crop&w=1200&q=80",
};
